<div class="row">
    <div class="col-md-7">
        <app-three-d-table-report-backpack-problem></app-three-d-table-report-backpack-problem>
    </div>
    <div class="col-md-5">
        <app-table #commonTable class="threeDtable" [tableService]="threeDRecordsTableService"
            [dataService]="threeDRecordsDataService">
        </app-table>
    </div>
</div>